import { Component, DestroyRef, OnDestroy, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { UserInfo, UserService } from "../../../services/user.service";

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html'
})
export class UserInfoComponent implements OnInit, OnDestroy {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly userSvc = inject(UserService);
    user: UserInfo;
    private _timerHandle: number;
    greeting: string;
    username: string;
    role: string;

    SetTimeGreeting() {
        let now = new Date();
        let hour = now.getHours();

        if ((hour >= 0 && hour <= 4) || hour >= 18) {
            this.greeting = 'Good evening';
        } else if (hour > 4 && hour < 12) {
            this.greeting = 'Good morning';
        } else if (hour >= 12 && hour < 18) {
            this.greeting = 'Good afternoon';
        }

        // Set up a one hour timer from now to check this again.
        this._timerHandle = window.setTimeout(() => {
            this.SetTimeGreeting();
        }, 60 * 60 * 1000);
    }

    ngOnChanges() {
        this.username = (this.user.FirstName.toLowerCase() || '') + ' ' + (this.user.LastName.toLowerCase() || '');
        this.role = this.user.CurrentRole;
    }

    ngOnInit() {
        //this.SetTimeGreeting();

        this.userSvc.UserSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => {
            if (user != null) {
                this.user = user;
                this.username = (this.user.FirstName.toLowerCase() || '') + ' ' + (this.user.LastName.toLowerCase() || '');
                this.role = this.user.CurrentRole;
            }
        });



    }

    ngOnDestroy() {
        if (this._timerHandle) window.clearTimeout(this._timerHandle);
        this._timerHandle = null;
    }
}